import { Section } from './Sections';

const DEFAULT_ITEMS = new Map([
  ['Android or iOS7 Smartphones', 'At least one of these is a necessity, since we will be using an app called Cluekeeper for the hunt.'],
  ['Pencils', 'for taking notes and working out ideas'],
  ['Paper', 'graph paper is usually useful'],
  ['Writing surface', 'such as a clip board or notebook'],
  ['Scissors', 'some content require cutting'],
  ['Tape', 'some content require assembly'],
  ['References', 'you\'ll be given a code sheet and if you have a smartphone you\'ll be allowed to use it'],
  ['Water and snacks', 'while there will be places to stop, it\'s best to be prepared'],
  ['Picnic Blanket', 'You may spend some of your time sitting on the ground. A picnic blanket can make this a much more pleasant experience'],
  ['Sunscreen, Hat, or other Sun Protection' , 'It will '],
  ['Good walking shoes', 'DASH does involve some walking, so keep your feet happy']
]);

const DEFAULT_LOCATION = "The exact start location is still being determined. We will update this space when we know more";

const DEFAULT_TIME = 'We expect that most teams will solve all content in ~6 hours. DASH will start promptly at the posted start time so please arrive ' +
'15 minutes early to check in and receive your first puzzle. Typically teams break for lunch around noon, and then ' +
'complete the day around 5pm.';

function standardSections(email, location = DEFAULT_LOCATION, time = DEFAULT_TIME, addedItems = {}) {
  const allItems = new Map([...DEFAULT_ITEMS, ...addedItems]);

  var itemText = "";
  allItems.forEach( (value, key) => {
    itemText += `<li><strong>${key}</strong> - ${value}</li>`;
  });


  const sections = [
    new Section('What is DASH?', 'DASH is a day-long walking puzzle solving event. If you choose to participate, ' +
        'the challenge will take your team from stop to stop, while you work together as a ' +
        'team, wracking your brains to solve content involving wordplay, spatial reasoning, and pop culture trivia.'),

    new Section('Where and when is all this taking place?', location, time),

    new Section('I\'ve never done one of these before... is it hard?', 'When you sign up, you\'ll be asked for a team ' +
        'experience level. This year we will have puzzle tracks for two levels:',
        '<ul>' +
        '<li><strong>Novice</strong>: If you have never attended a DASH, BAPHL ("Boston Area Puzzle Hunt League") hunt, ' +
        'or the MIT Mystery Hunt, and you\'ve never solved content more complex than a Sudoku, American Crossword, or ' +
        'Paint by Numbers, this is the level for you. This may also be a good level for smaller teams of experienced players.</li>' +
        '<li><strong>Expert</strong>: If you have a lot of experience with past DASHes, the MIT Mystery Hunt, any ' +
        'BAPHL hunts, or solving a variety of other types of non-traditional content, this is the level for you.</li>' +
        '</ul>'
    ),
    new Section('How big should my team be?', 'We recommend a team of 3-4 people. Too large a team and it becomes harder ' +
        'to collaborate on the content; too small and having so few solvers may slow you. Also, since we charge a flat ' +
        'fee per team, it becomes more expensive per person.'),

    new Section('What Supplies will we need', '<ul>' + itemText + '</ul>'),

    new Section('What is ClueKeeper?', 'You will need at least one person on your team with a smartphone and a copy of ' +
        'the ClueKeeper mobile app. ClueKeeper allows you to check your answers, get hints, and more. ClueKeeper is ' +
        'completely free to download and install -- you won\'t have to pay an extra fee above and beyond your ticket ' +
        'price. A few days before the event, you will be able to download the hunt ahead of time. That way,' +
        'even if your phone doesn\'t have Internet access during the hunt, you won\'t have any problems. You can download ' +
        'the app from <a href="https://cluekeeper.com" >www.cluekeeper.com</a>'),

    new Section('What if it rains?', 'We\'ll play in any weather. If it looks particularly bad, game control will email you with ' +
        'details of an alternate locations.'),

    new Section('Any other questions?', `Please email <a href="mailto:${email}">${email}</a> for further questions.`),

    new Section('Interested in volunteering?', 'We always welcome more volunteers to help coordinate on the day-of. ' +
        'Additionally, we will need a few people to help play-test the final set of content before the big day. ' +
        `Please email <a href=${email}">${email}</a> for further information.`)
  ];
  return sections;
}

export default standardSections;




// WEBPACK FOOTER //
// ./src/cities/Standard-City.js